export default "__VITE_ASSET__zfVa7nZJ__"